import { Component } from '@angular/core';
import { DashboardCustomerKPIService, IDataLabel, ValueType } from '../../../services';
import { EventService } from '../../../services';
import { OnInit } from '@angular/core';
import { ChartDataset } from '../../../interfaces/kpis/customer-kpi-totals';
import { KPILivefeed, TaskTypeInformationDTO } from 'src/app/interfaces/kpis/kpi-livefeed';

@Component({
  selector: 'dashboard-customer-kpi-volume',
  templateUrl: './dashboard-customer-kpi-volume.component.html',
  styleUrls: ['./dashboard-customer-kpi-display.component.scss'],
})
export class DashboardCustomerKPIVolumeComponent implements OnInit {
  constructor(
    private dashboardKPIService: DashboardCustomerKPIService,
    private eventService: EventService,
  ) {}

  // pass to display component as Input
  metrics: any[];

  taskColors: string[];

  async ngOnInit() {
    this.eventService.CustomerKPIRefreshEvent.subscribe(() => {
      this.loadData();
    });
  }

  async loadData() {
    this.metrics = [];
    await this.setCompletedMovesMetric();
  }

  async setCompletedMovesMetric() {
    let liveFeedData = this.dashboardKPIService.liveFeedData;

    //Get all unique KPI labels (assumes all entries have same labels)
    const kpiLabels = liveFeedData[0]?.taskTypeInformations.map((t) => t.label) ?? [];

    //Build datasets for each KPI
    const set: ChartDataset[] = kpiLabels
      .map((label) => {
        const first = liveFeedData
          .find((feed) => feed.taskTypeInformations.some((t) => t.label === label))
          ?.taskTypeInformations.find((t) => t.label === label)!;

        return {
          label: label,
          data: liveFeedData.map((feed) => {
            const entry = feed.taskTypeInformations.find((t) => t.label === label);
            return entry?.data ?? 0;
          }),
          backgroundColor: first.backgroundColor,
          useLine: first.useLine ?? false,
        };
      })
      .filter((ds) => ds.data.some((val) => val !== 0)); //filter out all-0 labels (no data)

    // add the turndown metric data as a line series onto the end of the chart datasets
    set.push({
      label: 'Turndowns',
      data: this.dashboardKPIService.completedTotals.map((x) => x.turndowns),
      backgroundColor: 'rgba(201,0,87, 0.9)',
    });

    // let datasets = datas.filter(x => !x.hideInChart).map((data, index) => {
    //   return {
    //     ...data
    //     , fill: true
    //     , order: index + 1
    //     , datalabels: <IDataLabel>{ display: false }
    //     , borderColor: 'rgba(255,255,255,1)'
    //     , borderWidth: 2
    //     , type: 'bar'
    //     , lineTension: 0
    //   }
    // });

    let datasets = set.map((data, index) => {
      return {
        ...data,
        fill: !data.useLine,
        order: index + 1,
        datalabels: <IDataLabel>{ display: false },
        borderColor: data.useLine ? 'rgba(1, 1, 1, 0)' : 'rgba(255,255,255,1)',
        borderWidth: data.useLine ? 1 : 2,
        type: data.useLine ? 'line' : 'bar',
        lineTension: 0,
      };
    });

    // modify last dataset (turndowns) to be a line chart
    datasets[datasets.length - 1].type = 'line';
    datasets[datasets.length - 1].fill = false;
    datasets[datasets.length - 1].order = 0;
    datasets[datasets.length - 1].datalabels = {
      display: true,
      align: 'end',
      anchor: 'end',
      borderRadius: 4,
      font: {
        weight: 'bold',
      },
      formatter: (value, ctx) => {
        let value1 = set[0].data[ctx.dataIndex];
        if (value1 == 0) {
          return '0%';
        }
        let percentage = ((value / value1) * 100.0).toFixed(1) + '%';
        return percentage;

        //return `${value.toFixed(1)}%`

        // let sum = 0;
        // let dataArr = datas[0].data;
        // dataArr.map(data => {
        //   sum += data;
        // });
        // let percentage = `${(sum || 0) == 0 ? 100 : (value / sum).toFixed(1)}%`;
        // return percentage;
      },
    };

    let valueFormatter = {
      display: true,
      align: 'end',
      anchor: 'end',
      borderRadius: 4,
      font: {
        weight: 'bold',
      },
      formatter: (value, ctx) => {
        //console.log("Chart Context: ", ctx, " - Value: ", value);
        if (ctx.datasetIndex == 1) {
          let value1 = set[0].data[ctx.dataIndex];
          return value1;
        } else {
          return '';
        }
      },
    };

    datasets.forEach((ds, index) => {
      if (index < datasets.length - 1) {
        ds.datalabels = valueFormatter;
      }
    });

    //x.completedMoves == 0 ? 100 : (x.turndowns / x.completedMoves) * 100.0

    datasets[datasets.length - 1].borderColor = 'rgba(209, 59, 25, 0.7)';

    datasets = datasets.sort((a, b) => a.order - b.order);

    console.log('Volume Datas: ', set);

    let tableData = this.dashboardKPIService.getMetricTableData(set, true);
    //console.log("Volume table data: ", tableData);

    let values = [].concat.apply(
      [],
      set.map((x) => x.data),
    );
    let labels = liveFeedData.map((x) => x.dateLabel);

    let chartData = {
      chartType: 'bar',
      labels,
      options: this.dashboardKPIService.stackedChartOptions,
      datasets,
    };

    // create the data array to be shown in table form
    let headers = ['Date', ...set.map((x) => x.label)];

    let totalsRow = this.dashboardKPIService.getTotalsRow(set);

    let metric = {
      chartData,
      title: 'Completed Moves',
      liveFeed: true,
      valueType: ValueType.Number,
      data: values,
      headers,
      tableData,
      totalsRow,
    };

    this.metrics.push(metric);
  }
}
